import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter, Mail, Phone, MapPin } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

const Footer = () => {
    const { settings } = useSettings();
    const contact = settings?.contact || {};

    return (
        <footer className="relative mt-24 border-t border-border/60 bg-gradient-to-b from-transparent to-primary/5" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <div className="w-11 h-11 rounded-full overflow-hidden ring-2 ring-brand-gold/40 shadow-md bg-white">
                            <img
                                src={settings?.logo_url || "https://customer-assets-cm19k8pv.emergentagent.net/job_custom-collectibles-2/artifacts/vm51spgg_Screenshot%202026-07-23%20at%206.35.36%E2%80%AFAM.png"}
                                alt="Cherishables"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <span className="font-display text-xl font-bold text-primary">Cherishables</span>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-xs">
                        Handcrafted 3D miniatures made from your favorite moments. Turn memories into masterpieces.
                    </p>
                    <div className="flex gap-2 mt-5">
                        {contact.instagram && <a href={contact.instagram} aria-label="Instagram" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:text-primary"><Instagram className="w-4 h-4" /></a>}
                        {contact.facebook && <a href={contact.facebook} aria-label="Facebook" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:text-primary"><Facebook className="w-4 h-4" /></a>}
                        {contact.youtube && <a href={contact.youtube} aria-label="Youtube" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:text-primary"><Youtube className="w-4 h-4" /></a>}
                        {contact.twitter && <a href={contact.twitter} aria-label="Twitter" className="w-9 h-9 rounded-full glass flex items-center justify-center hover:text-primary"><Twitter className="w-4 h-4" /></a>}
                    </div>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-4">Shop</h4>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li><Link to="/shop?category=single" className="hover:text-primary">Single Miniatures</Link></li>
                        <li><Link to="/shop?category=couple" className="hover:text-primary">Couple Miniatures</Link></li>
                        <li><Link to="/shop?category=family" className="hover:text-primary">Family Miniatures</Link></li>
                        <li><Link to="/shop?category=wedding" className="hover:text-primary">Wedding</Link></li>
                        <li><Link to="/shop?category=pet" className="hover:text-primary">Pet Miniatures</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-4">Support</h4>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li><Link to="/how-it-works" className="hover:text-primary">How It Works</Link></li>
                        <li><Link to="/track" className="hover:text-primary">Track Order</Link></li>
                        <li><Link to="/faqs" className="hover:text-primary">FAQs</Link></li>
                        <li><Link to="/contact" className="hover:text-primary">Contact Us</Link></li>
                        <li><Link to="/dashboard" className="hover:text-primary">My Account</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold mb-4">Get in touch</h4>
                    <ul className="space-y-3 text-sm text-muted-foreground">
                        <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-primary mt-0.5" /><span>{contact.email || "hello@cherishables.com"}</span></li>
                        <li className="flex items-start gap-2"><Phone className="w-4 h-4 text-primary mt-0.5" /><span>{contact.phone || "+91 90000 00000"}</span></li>
                        <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-primary mt-0.5" /><span>{contact.address || "Bangalore, India"}</span></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border/60 py-6 text-center text-xs text-muted-foreground">
                © {new Date().getFullYear()} Cherishables. Handcrafted with love in India.
            </div>
        </footer>
    );
};

export default Footer;
